import { RootStateOrAny, useSelector } from 'react-redux';

import { SnapshotsState } from './reducer';

export const selectSnapshots = ({ snapshots }: RootStateOrAny): SnapshotsState => snapshots;

export const useCurrentSnapshot = () => useSelector(selectSnapshots);
